
import MapCommand from './MapCommand';

export default class MapCommandExecCode extends MapCommand {

    constructor(options) {
        super(options);
        this._name = 'EXEC_CODE';
    }

    execute(olMap, params) {
        let map = olMap.getMap();
        if (params.callback) {
            params.callback(map, params.params, olMap);
        }
    }
}
